/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/nomina'

export default {
    get: params => {
        let customRoute = `${route}?${params.customFilter}`
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: params => Api().get(`${route}`, { crossDomain: true })
}
